import Breadcrumbs from "components/Common/Breadcrumb"
import React, { useEffect, useMemo, useState } from "react"
import { Col, Container, Row } from "reactstrap"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import ConfigUrl, { axiosbaseurl } from "../config"
import { useNavigate } from "react-router-dom"
import { usePermissionData } from "AppContext"
import PermittedComponent from "PermittedComponent"
import Loader from "pages/Loader"
import { RiArrowUpDownFill } from "react-icons/ri"
import { Modal, ModalHeader, ModalBody } from "reactstrap"

// 🔹 Aggregate stocks across portfolios
const aggregateStocks = portfolios => {
  const stockMap = {}

  portfolios.forEach(portfolio => {
    const details = JSON.parse(portfolio.stockDetails || "[]")

    details.forEach(stock => {
      if (!stockMap[stock.Symbol]) {
        stockMap[stock.Symbol] = {
          Symbol: stock.Symbol,
          Name: stock.Name,
          ISIN: stock.ISIN,
          totalQty: 0,
          customers: [],
        }
      }

      stockMap[stock.Symbol].totalQty += stock.PurchaseQty

      // push customer-wise detail
      stockMap[stock.Symbol].customers.push({
        customerName: portfolio.customer?.customerName,
        clientId: portfolio?.customer?.clientId,
        qty: stock.PurchaseQty,
        amount: stock.PurchaseAmount,
      })
    })
  })

  return Object.values(stockMap) // return array for table display
}

const StockPurchase = () => {
  document.title = "StockPurchase | Return First Investments"

  const { checkAccess } = usePermissionData()
  const Navigate = useNavigate()

  const [Data, setData] = useState([])
  const [stockSummary, setStockSummary] = useState([])
  const [selectedStock, setSelectedStock] = useState(null)
  const [Loading, setLoading] = useState(false)

  console.log(selectedStock)

  const [page, setPage] = useState(1)
  const [items_perpage, setItemsPerPage] = useState(10)

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`portfolio`)
      if (response?.data?.success) {
        const aggregated = aggregateStocks(response?.data?.data)
        setStockSummary(aggregated)
        setData(aggregated)
      }
    } catch (e) {
      console.log("Error", e.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }

  // 🔹 Filter by stock name
  const filterByName = e => {
    const val = e.target.value.toLowerCase()
    const filteredData = Data.filter(stock =>
      stock.Name.toLowerCase().includes(val)
    )
    setStockSummary(filteredData)
  }

  const total_pages = Math.ceil(stockSummary?.length / items_perpage)

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  // 🔹 Sorting state
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  })

  // 🔹 Sorting logic (only Stock Name & Qty)
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return stockSummary

    const sortableItems = [...stockSummary]
    sortableItems.sort((a, b) => {
      let aValue, bValue

      switch (sortConfig.key) {
        case "Name":
          aValue = a.Name.toLowerCase()
          bValue = b.Name.toLowerCase()
          break
        case "totalQty":
          aValue = a.totalQty
          bValue = b.totalQty
          break
        default:
          return 0
      }

      if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1
      if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1
      return 0
    })

    return sortableItems
  }, [stockSummary, sortConfig])

  const final_data = sortedData?.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  const requestSort = key => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  const getSortArrow = key => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "▲" : "▼"
    }
    return <RiArrowUpDownFill size={18} />
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(1, 1)}>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title={""} breadcrumbItem={"Stock Purchase"} />

            <div className="card p-2 py-3">
              <div className="d-flex flex-column flex-xl-row justify-content-between">
                <div className="search-box position-relative">
                  <input
                    className="form-control ps-6"
                    placeholder="Search Stock"
                    onChange={filterByName}
                  />
                  <i className="bx bx-search-alt search-icon"></i>
                </div>
              </div>

              <div className="table-responsive mt-4">
                <table className="mb-0 table Custom-Table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("Name")}
                      >
                        Stock Name {getSortArrow("Name")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("totalQty")}
                      >
                        Total Qty {getSortArrow("totalQty")}
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {final_data?.map((item, index) => (
                      <tr key={item?.Symbol}>
                        <td>{(page - 1) * items_perpage + index + 1}</td>
                        <td>{item?.Symbol}</td>
                        <td>{item?.totalQty}</td>
                        <td className="d-flex justify-content-center">
                          <button
                            className="btn Edit-Button me-2 rounded-5"
                            onClick={() => setSelectedStock(item)}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))}

                    {final_data.length === 0 && (
                      <tr>
                        <td colSpan={4} className="rounded-3 text-center">
                          No Stocks Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="d-flex align-items-center justify-content-between my-4 px-2">
                <p className="mb-0 fs-7">
                  Showing {final_data?.length} out of {stockSummary?.length}{" "}
                  stocks.
                </p>
                <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                  <div
                    className="bd-number-pagination cursor-pointer rounded-2 me-2 fs-5"
                    onClick={() => changePage(page - 1)}
                  >
                    <FaChevronLeft />
                  </div>
                  {(() => {
                    const maxVisiblePages = 5
                    const startPage = Math.max(
                      1,
                      page - Math.floor(maxVisiblePages / 2)
                    )
                    const endPage = Math.min(
                      total_pages,
                      startPage + maxVisiblePages - 1
                    )
                    const visiblePages = []

                    for (let i = startPage; i <= endPage; i++) {
                      visiblePages.push(i)
                    }

                    return visiblePages.map(pagecount => (
                      <div
                        key={pagecount}
                        className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-5 ${
                          page === pagecount ? "activepage" : ""
                        }`}
                        onClick={() => changePage(pagecount)}
                      >
                        {pagecount < 10 ? "0" + pagecount : pagecount}
                      </div>
                    ))
                  })()}
                  <div
                    className="bd-number-pagination cursor-pointer rounded-2 ms-2 fs-5"
                    onClick={() => changePage(page + 1)}
                  >
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>

        {/* 🔹 Modal to show customer-wise holdings */}
        <Modal
          isOpen={!!selectedStock}
          toggle={() => setSelectedStock(null)}
          size="lg"
        >
          <ModalHeader toggle={() => setSelectedStock(null)}>
            Stock Holdings - {selectedStock?.Symbol}
          </ModalHeader>
          <ModalBody>
            <table className="table">
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>Quantity</th>
                  <th>Invested Amount</th>
                </tr>
              </thead>
              <tbody>
                {selectedStock?.customers?.map((c, idx) => (
                  <tr key={idx}>
                    <td>{`${c.customerName} (${c.clientId})`}</td>
                    <td>{c.qty}</td>
                    <td>₹ {c.amount.toLocaleString("en-IN")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </ModalBody>
        </Modal>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default StockPurchase
